'use strict';

function spaceSplit(str) {
  return str.split(' ');
}

module.exports = spaceSplit;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/spaceSplit.js
// module id = 63
// module chunks = 0